<template>
  <div id="app">
    <!--导航条-->
    <!--<gheader type="home"></gheader>-->
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav type="home"></grednav>
    <!--登录一行-->
    <div id="carousel-generic" class="row-login carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carousel-generic" data-slide-to="0" class="active"></li>
        <li data-target="#carousel-generic" data-slide-to="1"></li>
        <li data-target="#carousel-generic" data-slide-to="2"></li>
      </ol>
      <div class="main-width set-position">
        <div class="log-in">
          <div>
            <p>你好，欢迎来到南方水泥！</p>
            <a :href="cashome">
              <button class="form-control btn btn-login action">立即登录</button>
            </a>
            <!--<a-->
              <!--href="javascript:;" @click="enterlink" id="supply-register">-->
              <a href="agreement.html?register" target="_blank" class="form-control btn btn-default btn-apply">供应商注册</a>
            <!--</a>-->
            <p><a
              href="javascript:;" @click="enterlink">还没有账号?</a>
              <!--&nbsp;|&nbsp;<a-->
              <!--href="#">忘记密码?</a>-->
            </p>
          </div>
          <hr/>
          <div style="margin-top: 19px">
            <h5><img src="static/imgs/helpCenter.png" alt=""/>&nbsp;帮助中心</h5>
            <p><a href="manual.html" target="_blank">供应商操作手册</a>&nbsp;|&nbsp;<a href="#">供应商注册视频</a></p>
          </div>
        </div>
      </div>
      <div class="carousel-inner" role="listbox" id="getOnfocus">
        <div class="item active">
          <!--<a :href="southCement">-->
          <div class="carousel-bg carousel-bg1"></div>
          <!--</a>-->
        </div>
        <div class="item">
          <!--<a :href="southCement">-->
          <div class="carousel-bg carousel-bg2"></div>
          <!--</a>-->
        </div>
        <div class="item">
          <!--<a :href="southCement">-->
          <div class="carousel-bg carousel-bg3"></div>
          <!--</a>-->
        </div>
      </div>
    </div>
    <!--主要内容展示-->
    <div class="row-content">
      <div class="main-width">
        <div class="bid-info pull-left">
          <div class="form-group">
            <infotable class="table-latest" v-bind:tableTitle="tableTitle[0]"
                       v-bind:tableContent="tableContent['latest']" v-bind:which="tableType[0]"
            ></infotable>
          </div>
          <div class="form-group">
            <infotable class="table-area" datatype="area" :tableTitle="tableTitle[1]"
                       v-bind:tableContent="tableContent['area']"
                       v-bind:which="tableType[1]"
            ></infotable>
          </div>
          <div class="form-group">
            <infotable class="table-type" datatype="type" v-bind:tableTitle="tableTitle[2]"
                       v-bind:tableContent="tableContent['type']"
                       v-bind:which="tableType[2]"
            ></infotable>
          </div>
        </div>
        <div class="bid-notice pull-right">
          <div class="form-group">
            <notice type="bidding" :apiUrl="noticeUrl[1]" :num="2"></notice>
          </div>
          <div class="form-group">
            <notice type="company" :apiUrl="noticeUrl[0]" :ajaxType="'get'"></notice>
          </div>
          <div class="form-group">
            <notice type="clarify"></notice>
          </div>
          <div class="form-group">
            <notice type="links" id="notice-links"></notice>
          </div>
        </div>
      </div>
    </div>
    <!--注册流程-->
    <regflows></regflows>
    <!--合作供应商-->
    <gsupplier></gsupplier>
    <!--footer-->
    <gfooter></gfooter>
  </div>
</template>

<script>
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import regflows from 'components/reg-flows'
  import gsupplier from 'components/G-supplier'
  import gfooter from 'components/G-footer'
  import notice from 'components/notice'
  import infotable from 'components/info-table'
  import {apiLinks} from '../../api/links.js'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav,
      regflows,
      gsupplier,
      gfooter,
      notice,
      infotable
    },
    mounted: function () {
      this.enterlink()
    },
    data () {
      return {
//        area: 'area',
        cashome: 'cashome.html?r=' + Math.random(),
        apiUrl: '',
        applylink: '',
        southCement: apiLinks.southCement['home'],
        tableTitle: [
          '最新采购信息',
          '按区域查看',
          '按类别查看'
        ],
        tableContent: {
          latest: [
            '最新项目'
          ],
          area: [
            '全部',
            '上海',
            '浙江',
            '江西',
            '湖南',
            '广西',
            '江苏',
            '安徽',
            '福建'
          ],
          type: [
            '全部'
          ]
        },
        tableType: [
          'latest',
          'area',
          'type'
        ],
        noticeUrl: [
          apiLinks.notice['company'],
          apiLinks.notice['bidding'],
          '2'
        ]
      }
    },
    methods: {
      enterlink: function () {
        let str = apiLinks.register
        this.applylink = str
//        let _it = document.getElementById('getOnfocus')
//        _it.onfocus()
      }
    }
  }
</script>
<style>
  @import 'home.css';
</style>



// WEBPACK FOOTER //
// home.vue?264fc0f7